<section class="cancellation-settings" aria-labelledby="cancellation-settings-title">
  <div class="cancellation-settings__loading" *ngIf="isLoading">
    Loading cancellation settings...
  </div>

  <ng-container *ngIf="!isLoading">
    <h4 id="cancellation-settings-title" class="cancellation-settings__title">
      Cancellation &amp; refund
    </h4>

    <p class="cancellation-settings__notice" *ngIf="loadFailed">
      The current settings could not be loaded, so they cannot be changed here.
      <button type="button" class="cancellation-settings__link" (click)="retry()">Retry</button>
    </p>

    <div class="cancellation-settings__body">
      <label class="cancellation-settings__toggle-row">
        <span class="cancellation-settings__toggle">
          <input
            type="checkbox"
            class="cancellation-settings__toggle-input"
            role="switch"
            [checked]="settings.enabled"
            [disabled]="isInteractionDisabled"
            [attr.aria-checked]="settings.enabled"
            aria-label="Allow attendants to cancel and refund purchases"
            (change)="onToggleEnabled()"
          />
          <span class="cancellation-settings__toggle-track" aria-hidden="true"></span>
        </span>
        <span class="cancellation-settings__toggle-text">
          <span class="cancellation-settings__label"
            >Allow attendants to cancel and refund purchases</span
          >
          <span class="cancellation-settings__hint">
            Shows Cancel and Refund on Orders, the Active Membership pop-up and the Customers tabs
            for every attendant and admin. Memberships keep redeeming until their renewal date;
            completed items can only be refunded.
          </span>
        </span>
        <span class="cancellation-settings__status" *ngIf="isSaving">Saving...</span>
      </label>

      <p class="cancellation-settings__notice" *ngIf="!globallyEnabled">
        Not yet switched on for this environment by Way. Your setting is saved and takes effect when
        it is.
      </p>

      <ng-container *ngIf="settings.enabled">
        <label class="cancellation-settings__toggle-row cancellation-settings__toggle-row--nested">
          <span class="cancellation-settings__toggle">
            <input
              type="checkbox"
              class="cancellation-settings__toggle-input"
              role="switch"
              [checked]="settings.prorated_refund_enabled"
              [disabled]="isInteractionDisabled"
              [attr.aria-checked]="settings.prorated_refund_enabled"
              aria-label="Offer prorated refunds"
              (change)="onToggleProrated()"
            />
            <span class="cancellation-settings__toggle-track" aria-hidden="true"></span>
          </span>
          <span class="cancellation-settings__toggle-text">
            <span class="cancellation-settings__label">Offer prorated refunds</span>
            <span class="cancellation-settings__hint">
              Adds a Prorated option when cancelling a membership or prepaid book, worth the unused
              part of the last charge. When off, only No refund, Full and Custom are offered.
            </span>
          </span>
        </label>

        <div class="cancellation-settings__locations">
          <p class="cancellation-settings__subtitle">Locations</p>

          <p class="cancellation-settings__hint" *ngIf="!locations.length">
            No active locations found.
          </p>

          <div class="cancellation-settings__location-list" *ngIf="locations.length">
            <label
              class="cancellation-settings__location"
              *ngFor="let location of locations; trackBy: trackLocation"
              [class.cancellation-settings__location--on]="
                !isRestrictedToLocations || isLocationSelected(location.id)
              "
            >
              <input
                type="checkbox"
                class="cancellation-settings__checkbox"
                [checked]="!isRestrictedToLocations || isLocationSelected(location.id)"
                [disabled]="isInteractionDisabled"
                (change)="onToggleLocation(location.id)"
              />
              <span>{{ locationLabel(location) }}</span>
            </label>
          </div>

          <div class="cancellation-settings__location-actions">
            <ng-container *ngIf="isRestrictedToLocations; else unrestricted">
              <button
                type="button"
                class="cancellation-settings__link"
                [disabled]="isInteractionDisabled"
                (click)="onAllowEveryLocation()"
              >
                Allow every location
              </button>
            </ng-container>
            <ng-template #unrestricted>
              <span class="cancellation-settings__hint"
                >On at every location. Untick a location to turn it off there.</span
              >
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</section>
